module.exports = __webpack_public_path__ + "static/media/contact-avatar.4e2d31a5.png";